import { Card, Box, Typography } from "@mui/material";
import TaskTable from "./TaskTable";

const MetricBox = ({ title, value }) => {
	return (
		<Card
			sx={{
				textAlign: "center",
				width: "30%",
				padding: "2",
			}}
		>
			<Box display='inline'>
				<Typography
					component="h2"
					variant="h6"
					color="primary"
				>
					{title}
				</Typography>
				<Typography
					component="h2"
					variant="h6"
				>
					{value}
				</Typography>
			</Box>
		</Card>
	);
};

const ActiveTaskTab = ({
	tasks,
	t,
	editTask,
	toggleDialogIsOpen,
	setDialogType,
	setDialogData,
	deleteTask,
	resetDialogData,
	copyTask,
}) => {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
			<Box>
				<Box
					sx={{
						flexDirection: "row",
						display: "flex",
						justifyContent: "space-between",
						gap: '24px'
					}}
				>
					<MetricBox
						title={t("Open Tasks")}
						value={tasks.filter((task) => task.status === "OPEN").length}
						style={{ width: "10%" }}
					/>
					<MetricBox
						title={t("In Progress")}
						value={tasks.filter((task) => task.status === "IN_PROGRESS").length}
						style={{ width: "10%" }}
					/>
					<MetricBox
						title={t("Closed Tasks")}
						value={tasks.filter((task) => task.status === "CLOSED").length}
						style={{ width: "10%" }}
					/>
				</Box>
			</Box>
			<Card
				sx={{
					p: 3,
					height: "calc(100vh - 220px)",
					width: "100%",
				}}
			>
				<TaskTable
					tasks={tasks.filter((task) => task.status !== "CLOSED")}
					t={t}
					setDialogType={setDialogType}
					toggleDialogIsOpen={toggleDialogIsOpen}
					deleteTask={deleteTask}
					setDialogData={setDialogData}
					resetDialogData={resetDialogData}
					copyTask={copyTask}
				/>
			</Card>
		</Box>
	);
};

export default ActiveTaskTab;
